module.exports = __webpack_public_path__ + "img/UsersGroupTwoRounded.df167446.svg";